<div
    #trigger="cdkOverlayOrigin"
    cdkOverlayOrigin
    class="st-cast-object-item"
    (mouseleave)="onMouseMove($event)"
    (mouseenter)="isPanelOpen = true">
    <ng-container [ngSwitch]="data()?.Type">
        <ng-template [ngSwitchCase]="ObjectTypesEnum.TOPIC">
            <button
                mat-icon-button
                class="st-cast-object-item-fill">
                <mat-icon class="st-cast-object-item-icon"> text_snippet </mat-icon>
            </button>
        </ng-template>
        <ng-template ngSwitchDefault>
            <st-icon
                *ngIf="data"
                hasBorder
                class="st-cast-object-item-icon-assignment"
                [type]="assignmentIconType()"
                [data]="assignment()" />
        </ng-template>
    </ng-container>
    <div class="st-cast-object-item-content">
        <div class="st-cast-object-item-content__title">{{ data().Title }}</div>
        <div class="st-cast-object-item-content__subtitle">{{ getItemCreator() }}</div>
    </div>
</div>
<mat-divider
    *ngIf="!isLast"
    class="st-cast-object-item-divider" />
<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isPanelOpen"
    [cdkConnectedOverlayPositions]="connectedPositions"
    (attach)="panelAttached()">
    <div class="st-cast-object-item-container-overlay">
        <div class="st-cast-object-item-container-overlay--top-row">
            @if (data()?.Type === ObjectTypesEnum.TOPIC) {
                <st-topic-type
                    mat-chip-grid
                    class="st-cast-object-item-container-overlay__topic-type"
                    [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTTopicType)"
                    [record]="data()"
                    [value]="data()[PSTFieldNames.PSTTopicType]" />
            } @else if (data()?.Type === ObjectTypesEnum.ASSIGNMENT) {
                <st-assignment-type
                    class="st-cast-object-item-container-overlay__topic-type"
                    showLabel
                    showIcon="false"
                    [data]="data()"
                    [value]="assigmentType()" />
            }
            <div
                class="st-cast-object-item-container-overlay--status"
                [matTooltip]="status()">
                {{ status() }}
            </div>
        </div>
        <div class="st-cast-object-item-container-overlay--title">{{ data()?.Title }}</div>
        <st-text-area-overlay
            class="st-cast-object-item-container-overlay--desc"
            minRows="1"
            minHeight="1rem"
            [disabled]="true"
            [value]="data()?.Description"
            [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.Description].DefaultCaption" />
        <div class="st-cast-object-item-container-overlay__owner">
            <span class="st-cast-object-item-container-overlay__owner--label"> {{ ownersLabel() }} </span>
            <div class="st-cast-object-item-container-overlay__owner--item">
                <mat-basic-chip *ngFor="let owner of owners()">
                    <st-avatar
                        small
                        matChipAvatar
                        [userId]="owner" />
                    {{ owner | titlecase }}
                </mat-basic-chip>
            </div>
        </div>
        @if (desk()?.length > 0) {
            <div class="st-cast-object-item-container-overlay__desk">
                <span class="st-cast-object-item-container-overlay__desk--label"> {{ languageSettings().PSTWebDesksLabel }} </span>
                <div class="st-cast-object-item-container-overlay__desk--item">
                    <mat-basic-chip *ngFor="let item of desk()">
                        {{ item }}
                    </mat-basic-chip>
                </div>
            </div>
        }

        <div class="st-cast-object-item-container-overlay__date-time">
            <span class="st-cast-object-item-container-overlay__date-time--label"> {{ globalTablesService.FieldDefsDict[PSTFieldNames?.TargetPublicationDate]?.DefaultCaption }} </span>
            <div class="st-cast-object-item-container-overlay__date-time--item">
                <mat-icon class="material-symbols-outlined">today</mat-icon>
                {{
                    getItemString(
                        PSTFieldNames?.TargetPublicationDate,
                        itemStringCache,
                        i18n(),
                        globalTablesService,
                        data(),
                        getInnerProp,
                        highlightPipe,
                        searchString(),
                        clientTimeZone().id,
                        currentTimeZone().id
                    )
                }}
            </div>
        </div>
        @if (viewStateCustomItems()?.length > 0) {
            <div class="st-cast-object-item-container">
                <ng-template
                    let-idx
                    ngFor
                    [ngForOf]="[0, 1, 2, 3]">
                    <div class="st-topic-item-container-item">
                        @if (viewStateCustomItems()[idx]) {
                            <ng-container
                                [ngTemplateOutlet]="customField"
                                [ngTemplateOutletContext]="{ item: viewStateCustomItems()[idx], data: data, validation: viewStateCustomItems()[idx].Validation?.toUpperCase() }" />
                        }
                    </div>
                </ng-template>
            </div>
        }
        <ng-template
            #customField
            let-item="item"
            let-data="data"
            let-validation="validation">
            <ng-container [ngSwitch]="validation">
                <ng-template [ngSwitchCase]="FieldDefValidations.LOOKUPLIST">
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <mat-chip-listbox class="st-cast-object-item-container-overlay__custom-fields--item">
                                <mat-basic-chip *ngFor="let item of data()?.[item.ID]">
                                    {{ item.displayText }}
                                </mat-basic-chip>
                            </mat-chip-listbox>
                        </div>
                    }
                </ng-template>

                <ng-template [ngSwitchCase]="FieldDefValidations.TEXT">
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <st-text-area-overlay
                                class="st-cast-object-item-container-overlay__custom-fields--text-item"
                                minRows="1"
                                minHeight="1rem"
                                [disabled]="true"
                                [value]="data()?.[item.ID]"
                                [placeholder]="item.DefaultCaption" />
                        </div>
                    }
                </ng-template>

                <ng-template [ngSwitchCase]="FieldDefValidations.COMBOBOX">
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--item">
                                <mat-basic-chip *ngFor="let item of data()?.[item.ID]">
                                    {{ item }}
                                </mat-basic-chip>
                            </div>
                        </div>
                    }
                </ng-template>

                <ng-template [ngSwitchCase]="FieldDefValidations.CHECKLIST">
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--item">
                                <mat-basic-chip *ngFor="let item of data()?.[item.ID]">
                                    {{ item }}
                                </mat-basic-chip>
                            </div>
                        </div>
                    }
                </ng-template>

                <ng-template [ngSwitchCase]="FieldDefValidations.CHECKBOX">
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <st-check-box
                                class="st-cast-object-item-container-overlay__custom-fields--value"
                                [disabled]="true"
                                [label]="'APTopStory'"
                                [contentEditable]="false"
                                [value]="data()?.[item.ID]" />
                        </div>
                    }
                </ng-template>
                <ng-template [ngSwitchCase]="FieldDefValidations.STAFFIDLIST">
                    @if (data()?.[item.ID]?.length > 0) {
                        <div class="st-cast-object-item-container-overlay__owner">
                            <span class="st-cast-object-item-container-overlay__owner--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__owner--item">
                                <mat-basic-chip *ngFor="let owner of data()?.[item.ID]">
                                    <st-avatar
                                        small
                                        matChipAvatar
                                        [userId]="owner" />
                                    {{ owner | titlecase }}
                                </mat-basic-chip>
                            </div>
                        </div>
                    }
                </ng-template>

                <ng-template [ngSwitchCase]="FieldDefValidations.TREE">
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--text-item">
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone().id, currentTimeZone().id) }}
                            </div>
                        </div>
                    }
                </ng-template>

                <ng-template [ngSwitchCase]="FieldDefValidations.ADDRESS">
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__custom-fields">
                            <span class="st-cast-object-item-container-overlay__custom-fields--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__custom-fields--text-item">
                                <st-text-area-overlay
                                    class="st-cast-object-item-container-overlay__custom-fields--text-item"
                                    minRows="1"
                                    minHeight="1rem"
                                    [disabled]="true"
                                    [value]="
                                        getItemString(
                                            item,
                                            itemStringCache,
                                            i18n(),
                                            globalTablesService,
                                            data(),
                                            getInnerProp,
                                            highlightPipe,
                                            searchString(),
                                            clientTimeZone().id,
                                            currentTimeZone().id
                                        )
                                    "
                                    [placeholder]="item.DefaultCaption" />
                            </div>
                        </div>
                    }
                </ng-template>
                <ng-template [ngSwitchCase]="FieldDefValidations.DATETIMERANGE">
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__date-time">
                            <span class="st-cast-object-item-container-overlay__date-time--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__date-time--item">
                                <mat-icon class="material-symbols-outlined">today</mat-icon>
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone().id, currentTimeZone().id) }}
                            </div>
                        </div>
                    }
                </ng-template>
                <ng-template [ngSwitchCase]="FieldDefValidations.DATE">
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__date-time">
                            <span class="st-cast-object-item-container-overlay__date-time--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__date-time--item">
                                <mat-icon class="material-symbols-outlined">today</mat-icon>
                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone().id, currentTimeZone().id) }}
                            </div>
                        </div>
                    }
                </ng-template>
                <ng-template ngSwitchDefault>
                    @if (data()?.[item.ID]) {
                        <div class="st-cast-object-item-container-overlay__date-time">
                            <span class="st-cast-object-item-container-overlay__date-time--label"> {{ item.DefaultCaption }} </span>
                            <div class="st-cast-object-item-container-overlay__date-time--item">
                                <mat-icon class="material-symbols-outlined">today</mat-icon>

                                {{ getItemString(item, itemStringCache, i18n(), globalTablesService, data(), getInnerProp, highlightPipe, searchString(), clientTimeZone().id, currentTimeZone().id) }}
                            </div>
                        </div>
                    }
                </ng-template>
            </ng-container>
        </ng-template>

        <button
            mat-button
            class="st-cast-object-item-container-overlay__button--approve"
            st-click-stop-propagation
            [class.st-cast-object-item-container-overlay__button--approve--active]="!data()?.PSTApproved"
            (click)="updateTopic(!data().PSTApproved, PSTFieldNames.PSTApproved)">
            @if (data()?.PSTApproved) {
                <mat-icon>done</mat-icon>
            }
            {{ approvedLabel() }}
        </button>

        <button
            mat-button
            color="primary"
            class="st-cast-object-item-container-overlay__button--open"
            (click)="itemClick.emit()">
            {{ languageSettings().PSTWebCastObjectsOpenButton }}
        </button>
    </div>
</ng-template>
